export default __webpack_public_path__ + "static/media/cross.a1c04659.svg";